/* eslint-disable @next/next/no-img-element */
import React, { useState, useEffect } from "react";
import Collapse from "@mui/material/Collapse";
import { useRouter } from "next/router";
import Link from "next/link";
import { useMediaQuery } from "react-responsive";
import { ReactSVG } from "react-svg";
import { getAssets } from "@unisearch/helpers";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { IconButton } from "@mui/material";
import styles from "./popular_group.module.scss";

const list = [
  {
    name: "Study in Australia",
    member: 700,
    image: "assets/images/persons/person6.png",
    slug: "study-in-australia",
  },
  {
    name: "Job in UK",
    member: 700,
    image: "assets/images/persons/person5.png",
    slug: "job-in-uk",
  },
  {
    name: "Study in Canada",
    member: 700,
    image: "assets/images/persons/person4.png",
    slug: "study-in-canada",
  },
  {
    name: "Study in Malyesia",
    member: 700,
    image: "assets/images/persons/person3.png",
    slug: "study-in-malyesia",
  },
  {
    name: "Study in Japan",
    member: 700,
    image: "assets/images/persons/person2.png",
    slug: "study-in-japan",
  },
];

const PopularGroup = ({ popularGroup }) => {
  const { asPath, query } = useRouter();
  const isMobile = useMediaQuery({
    query: "(max-width: 991px)",
  });
  const [open, setOpen] = useState(true);

  const handleClick = () => {
    setOpen(!open);
  };

  useEffect(() => {
    if (isMobile) {
      setOpen(false);
    }
  }, []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.heading}>
        <span>Popular Groups</span>
        {isMobile && (
          <IconButton disableRipple>
            {open ? (
              <FiChevronUp onClick={handleClick} />
            ) : (
              <FiChevronDown onClick={handleClick} />
            )}
          </IconButton>
        )}
      </div>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <ul className={styles.item_group_wrapper}>
          {popularGroup &&
            popularGroup?.length > 0 &&
            popularGroup?.map((item, i) => (
              <li key={i}>
                <div className={styles.img_wrapper}>
                  <img src={item?.thumbImageSrc} alt={item.name} />
                </div>
                <div>
                  <h2 className={styles.title}>
                    <Link legacyBehavior href={`/forum/group/${item.slug}`}>
                      <a>{item.title}</a>
                    </Link>
                  </h2>
                  <p className={styles.text}>
                    {item.totalMember === null ? "0" : item.totalMember} members
                  </p>
                </div>
              </li>
            ))}
        </ul>
      </Collapse>
    </div>
  );
};

export default PopularGroup;
